/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SubmittedInputs */

const en_submitted = /** @type {(inputs: SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitted`)
};

const de_submitted = /** @type {(inputs: SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingereicht`)
};

/**
* | output |
* | --- |
* | "Submitted" |
*
* @param {SubmittedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const submitted = /** @type {((inputs?: SubmittedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SubmittedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_submitted(inputs)
	return en_submitted(inputs)
});